module.exports = __webpack_public_path__ + "media/categorise.ebf3ce15.webm";